import clsx from 'clsx';
import AboutUsSiteInnerContainer from 'components/about-us/AboutUsSiteInnerContainer';
import { default as Header } from 'components/dashboard/common/DashboardComponentHeader';
import styles from './ReferralsHowItWorks.module.css';

type ReferralsStepsStyle = 'column' | 'row';

interface ReferralsSectionContainerProps {
  stepsStyle?: ReferralsStepsStyle;
}

const HOW_IT_WORKS_STEPS = [
  {
    title: 'Invite up to 3 friends',
    description: <>Existing players are not eligible to be referred</>,
    icon: '🤝',
  },
  {
    title: 'They join with 50% off',
    description: 'Your friends get a great start',
    icon: '🎁',
  },
  {
    title: <>More friends, more chances</>,
    description: (
      <>
        Every time your friends win prizes,
        <br className="mobileOnly" /> you will too{' '}
        <strong>and vice versa</strong>
      </>
    ),
    icon: '🥳',
  },
];

interface ReferralsHowItWorksStepsProps {
  stepsStyle: ReferralsStepsStyle;
}

const ReferralsHowItWorksSteps = ({
  stepsStyle,
}: ReferralsHowItWorksStepsProps) => {
  return (
    <div
      className={clsx(styles.stepsContainer, {
        [styles.row]: stepsStyle === 'row',
        [styles.column]: stepsStyle === 'column',
      })}
    >
      {HOW_IT_WORKS_STEPS.map((step, index) => (
        <div key={index} className={styles.step}>
          <div className={styles.icon}>{step.icon}</div>
          <div className={styles.textContent}>
            <h3 className={clsx(styles.stepTitle, 'noMargin', 'textAlignLeft')}>
              {step.title}
            </h3>
            <p className={clsx('noMargin', 'textAlignLeft')}>
              {step.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export const ReferralsHowItWorks = ({
  stepsStyle = 'column',
}: ReferralsSectionContainerProps) => {
  return (
    <AboutUsSiteInnerContainer borderRadius withPadding background="white">
      <div className={styles.container}>
        <Header
          separator
          title={'How it works'}
          subtitle={'Choose who you want to play with'}
        />
        <ReferralsHowItWorksSteps stepsStyle={stepsStyle} />
      </div>
    </AboutUsSiteInnerContainer>
  );
};
